import { Seo } from '../components/Seo'
import { Button } from '../components/common/Button'
import { Icon } from '../components/common/Icon'
import { LeafMark } from '../components/common/Logo'
import { AccentGlow } from '../components/common/AccentGlow'

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found (404)" description="The page you were looking for could not be found." path="/404" noIndex />
      <section
        className="grain relative flex min-h-[100svh] items-center overflow-hidden bg-night text-white"
        style={{ ['--leaf-vein' as string]: '#06231A' }}
      >
        <AccentGlow color="#159A3C" intensity={0.4} className="left-1/2 top-1/3 h-[36rem] w-[36rem] -translate-x-1/2" />
        <div className="container-x relative text-center">
          <LeafMark className="mx-auto mb-8 h-16 w-16 text-brand-400" />
          <p className="text-eyebrow font-semibold uppercase tracking-[0.24em] text-brand-300">Error 404</p>
          <h1 className="mt-4 font-display text-display-xl font-semibold">This field is fallow.</h1>
          <p className="mx-auto mt-5 max-w-md text-lead text-white/70">
            The page you’re looking for doesn’t exist or may have moved. Let’s get you back to solid ground.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Button to="/" variant="primary" size="lg">
              <Icon name="ArrowLeft" className="h-5 w-5" /> Back home
            </Button>
            <Button to="/catalog" variant="ghost-light" size="lg">
              Browse products
            </Button>
          </div>
        </div>
      </section>
    </>
  )
}
